import { useEffect } from 'react'

// 모달 배경(body) 스크롤 락 — refcount 기반(중첩 모달 안전, 마지막 해제 시에만 복원).
//
// ⚠ 설계 선택: react-remove-scroll 대신 body overflow 락을 쓴다. modal={false} 다이얼로그는
//    내부에 body-portal 되는 kit Select/DatePicker 팝업을 다수 내포한다. react-remove-scroll 은
//    wheel/touch 이벤트를 전역 차단해 RemoveScroll 경계 밖(=body-portal 팝업)의 스크롤까지 막는다
//    (긴 옵션 리스트 스크롤 불가). body overflow:hidden 은 배경 페이지 스크롤만 막고 팝업 자체의
//    overflow:auto 스크롤은 그대로 두므로 중첩 팝업이 깨지지 않는다.
let lockCount = 0
let prevOverflow = ''
let prevPaddingRight = ''

function acquireBodyScrollLock(): void {
  if (lockCount === 0) {
    const body = document.body
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
    prevOverflow = body.style.overflow
    prevPaddingRight = body.style.paddingRight
    body.style.overflow = 'hidden'
    // 스크롤바가 사라지며 생기는 레이아웃 시프트를 padding 으로 보정.
    if (scrollbarWidth > 0) {
      const current = Number.parseFloat(getComputedStyle(body).paddingRight) || 0
      body.style.paddingRight = `${current + scrollbarWidth}px`
    }
  }
  lockCount += 1
}

function releaseBodyScrollLock(): void {
  lockCount = Math.max(0, lockCount - 1)
  if (lockCount === 0) {
    document.body.style.overflow = prevOverflow
    document.body.style.paddingRight = prevPaddingRight
  }
}

/** enabled 인 동안 body 스크롤을 잠근다(언마운트/비활성 시 자동 해제). */
export function useBodyScrollLock(enabled: boolean): void {
  useEffect(() => {
    if (!enabled) return
    acquireBodyScrollLock()
    return releaseBodyScrollLock
  }, [enabled])
}
